export default "__VITE_ASSET__Nu5Z7P7Q__"